import { NumberInput } from "components/common/NumberInput";
import { FormFieldProps } from "./types";

const inputClass =
  "w-full rounded-md border border-gray-200 bg-white px-2 py-1 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-200";

export const FormField = (props: FormFieldProps) => {
  return (
    <div className="text-sm">
      <div className="text-sm font-medium text-gray-700 mb-1">
        {props.label}
      </div>
      <div className="text-gray-900">
        {props.onChange ? (
          <>
            {props.type === "textarea" ? (
              <textarea
                className={inputClass}
                rows={props.rows}
                value={props.value}
                onChange={(e) => props.onChange?.(e.target.value)}
                onBlur={props?.onBlur}
              />
            ) : props.type === "number" ? (
              <NumberInput
                value={props.value}
                onChange={(n) => props.onChange?.(n)}
                step={props?.step || 1}
                min={props.min}
                max={props.max}
                inputMode={props.inputMode}
              />
            ) : (
              <input
                className={inputClass}
                value={props.value}
                onChange={(e) => props.onChange?.(e.target.value)}
                onBlur={props?.onBlur}
              />
            )}
            {props.error && (
              <p className="mt-1 text-xs text-red-600">{props.error}</p>
            )}
          </>
        ) : (
          <div className="break-words">{props.value}</div>
        )}
      </div>
    </div>
  );
};
